<template>
  <div class="verify">
    <div class="inspire-title">{{ $t('assist.topicVerification') }}</div>
    <div
      class="result"
      v-html="$t('assist.isEffective', { sameTotal, similarTotal })"
    ></div>
    <div v-if="similarArticleList.length > 0">
      <div v-for="(item, index) in similarArticleList" :key="index">
        <div class="header">
          <div class="header-main">
            <span class="header-content">{{ item.paperTitle }}</span>
            <span class="header-caption">{{ $t('assist.journal') }}</span>
          </div>
          <img
            v-if="item.rdPaperId"
            @click="goRp(item.rdPaperId)"
            src="@/common/image/assist/rp.svg"
            alt=""
          />
        </div>
        <div class="body">
          <div class="original" v-if="item.abstractString">
            <span class="content">
              <span>
                <span class="original-caption"
                  >{{ $t('assist.abstract') }}
                </span> </span
              >{{ item.abstractString }}</span
            >
          </div>
          <div
            class="origin-rel"
            :class="
              index === similarArticleList.length - 1 ? 'origin-rel2' : ''
            "
          >
            <span>
              <span class="author">{{
                item.authors.length > 3
                  ? item.authors.slice(0, 3).join(', ') + ' ... '
                  : item.authors.slice(0, 3).join(', ')
              }}</span>
              <span class="journal" v-if="item.journalInfo.name"
                >- {{ item.journalInfo.name }}</span
              >
              <span class="factor" v-if="item.journalInfo['IF']"
                >- {{ $t('assist.IFactor') }}{{ item.journalInfo['IF'] }}</span
              >
            </span>
            <span style="float: right">
              <span class="date" v-if="item.publishedYear"
                >{{ $t('assist.year') }}{{ item.publishedYear }}</span
              >
              <span v-if="item.numCitesAll"
                >{{ $t('assist.citations') }}{{ item.numCitesAll }}</span
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { similarArticleInfo } from '@/api/assist'

export default defineComponent({
  props: {
    similarArticleList: {
      type: Array as PropType<similarArticleInfo[]>,
      default: () => [],
    },
    similarTotal: {
      type: Number,
      default: 0,
    },
    sameTotal: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    const goRp = (rdPaperId: string) => {
      window.open(`https://readpaper.com/paper/${rdPaperId}`, '_blank')
    }

    return {
      goRp,
    }
  },
  methods: {},
})
</script>

<style lang="less" scoped>
.verify {
  .result {
    font-size: 14px;
    color: #6b727f;
    margin-top: 13px;
    margin-left: 15px;
  }
  .body {
    .original {
      margin: 10px 0px 5px 15px;
      .content {
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.05em;
        color: #6b727f;
        padding-left: 5px;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        .original-caption {
          font-weight: 700;
          font-size: 12px;
          margin-right: 5px;
        }
      }
    }
    .origin-rel2 {
      border-bottom: 0px !important;
    }
    .origin-rel {
      margin-left: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #e5e5e5;
      font-style: normal;
      font-weight: 400;
      font-size: 11px;
      line-height: 22px;
      color: #a8abb3;
      .journal {
        font-style: italic;
      }
      .journal,
      .factor {
        margin: 0px 10px;
      }
      .date {
        margin-right: 10px;
      }
    }
  }
}
.verify {
  .header {
    display: flex;
    justify-content: space-between;
    margin-left: 15px;
    margin-top: 10px;
    img {
      cursor: pointer;
    }
    .header-main {
      color: #444444;
      margin-top: 10px;
      .header-caption {
        font-weight: 700;
        font-size: 11px;
        color: #9c9fa6;
        border: 1px solid #9c9fa6;
        border-radius: 5px;
        padding: 0px 3px;
        height: 18px;
        line-height: 16px;
        margin-left: 10px;
        display: inline-block;
      }
      .header-content {
        font-weight: 600;
        font-size: 18px;
        line-height: 25px;
      }
    }
  }
  .inspire-title {
    font-size: 18px;
    font-weight: 600;
    margin-top: 30px;
    border-left: 3px solid #0ca1bd;
    padding-left: 8px;
    color: #444444;
  }
}
.mobile-viewport {
  .verify {
    margin-right: 15px;
  }
  .verify .header .header-main .header-content {
    font-size: 15px;
  }
  .verify .header img {
    width: 75px;
  }
  .verify .inspire-title {
    font-size: 17px;
  }
}
</style>
